<header>
  <nav id="header" class="navbar navbar-expand-lg navbar-light ">
    <div class="container-fluid">
      <a href="javascript:;" class="logo d-flex align-items-center" [routerLink]="['/home']">
        <img src="assets/img/courtLogo.png" alt="logo">
        <!-- <span class="d-none d-lg-block">NiceAdmin</span> -->
      </a>
      <div class="d-lg-none">
        <div>e-Litigation Portal</div>
        <div>ระบบงานคดีปกครองอิเล็กทรอนิกส์</div>
      </div>
      <span class="server-test d-none d-sm-block d-lg-none">
        <!-- e-Litigation Dev Server -->
      </span>
      <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <!--เห็นบนจอ โทรศัพท์-->
        <div class="navbar-nav d-sm-none">
          <div class="row justify-content-center">
            <!-- <div class="col-12 col-sm-5">
              <div c>e-Litigation Portal</div>
              <div c>ระบบงานคดีปกครองอิเล็กทรอนิกส์</div>
            </div> -->
            <div class="col-auto col-sm-auto">
              <div class="server-test d-md-none">
                <!-- e-Litigation Dev Server -->
              </div>
            </div>
          </div>
        </div>
        <!--เห็นบนจอ โทรศัพท์-->

        <!--เห็นบนจอ คอม-->
        <div class="d-none d-lg-block">
          <div>e-Litigation Portal</div>
          <div>ระบบงานคดีปกครองอิเล็กทรอนิกส์</div>
        </div>
        <span class="server-test d-none d-lg-block">
          <!-- e-Litigation Dev Server -->
        </span>
        <!--เห็นบนจอ คอม-->
        <div class="navbar-nav">
        <ng-container *ngIf="user$ | async as _user">
          <a class="nav-link nav-icon" [routerLinkActive]="['active']" href="javascript:;" [routerLink]="['/home']">
            {{'MAIN'|translate}}
          </a>
          
          
          <a *ngIf="_user.firstName" class="nav-link nav-icon " [routerLinkActive]="['active']"
            href="javascript:;" [routerLink]="['/my-case']">
            {{'MY_CASE'|translate}}
          </a>
        </ng-container>
          <a class="nav-link nav-icon " [routerLinkActive]="['active']" href="javascript:;"
            [routerLink]="['/contact-us']">
            {{'CONTACT_US'|translate}}
          </a>
        </div>
        <div class="navbar-nav" style="padding-right: 8rem;"> <!-- style="padding-right: 8rem;" -->
          <ng-container *ngIf="user$ | async as _user"> 
            <div class="nav-item dropdown" *ngIf="_user.firstName" style="margin-top: auto; margin-bottom: auto;">
              <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                <!-- <img src="assets/img/profile-img.jpg" alt="Profile" class="rounded-circle"> -->
                <span class="dropdown-toggle">{{_user?.firstName}} {{_user?.lastName}}</span>
              </a><!-- End Profile Iamge Icon -->
              <div class="dropdown-menu profile">
                <!-- <a href="javascript:;" [routerLink]="['/edit-user']" class="dropdown-item dropdown-header"><h6>{{_user.firstName}} {{_user.lastName}}</h6></a> -->
                <a href="javascript:;" [routerLink]="['/edit-user']" class="dropdown-item dropdown-header" >
                  <span style="color:#444444 !important">{{'HEADER_PROFILE'|translate}}</span>
                </a>

                <!--*ngIf="isAdmin==true"-->
                <a href="javascript:;" [routerLink]="['/manual-admin']" class="dropdown-item dropdown-header" *ngIf="_user.firstName != '' && isAdmin==true">
                  <span style="color:#444444 !important">{{'MANUAL_ADMIN'|translate}}</span>
                </a>

                <!-- <a href="#" class="dropdown-item dropdown-header"><span>Web Designer</span></a> -->
                <hr class="dropdown-divider">
                <a class="dropdown-item d-flex align-items-center  dropdown-header" href="javascript:;"
                  (click)="logout()">
                  <i class="bi bi-box-arrow-right form-control-label"></i>
                  <span>ออกจากระบบ</span>
                </a>
              </div>
            </div>
          </ng-container>
<!--           <div class="nav-item dropdown pe-3">
            <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <i class="rounded-circle {{language?.flag}}"></i>
              <span class="d-none d-md-block dropdown-toggle ps-2 ">{{language?.name}}</span>
            </a> End Profile Iamge Icon 
            <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow flag">
              <li *ngFor="let language of languages">
                <a class="dropdown-item d-flex align-items-center" href="javascript:;"
                  (click)="setLanguage(language.lang)">
                  <i class="{{language.flag}}"></i>
                  <span class=" form-control-label">{{language.name}}</span>
                </a>
              </li>
            </div> End Profile Dropdown Items 
          </div> End Profile Nav  -->


        </div>
      </div>
    </div>
  </nav>
</header>